import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AppComponent } from '../app.component';
import { MainComponent } from '../main/main.component';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor() {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // La petición de token no se intercepta
        if (request.body && request.body.indexOf('grant_type') > -1) {
            return next.handle(request);
        }
        let tokenTAG = '';
        if (request.url.indexOf(AppComponent.getInstance().urlApiSSO) > -1 &&
            AppComponent.getInstance().urlApiSSO.length > 0 && AppComponent.getInstance().urlApiSSO.length > 0) {
            tokenTAG = 'token-import-SSO';
        } else {
            if (request.url.indexOf(MainComponent.getInstance().urlApi) > -1 &&
                MainComponent.getInstance().urlApi.length > 0 && MainComponent.getInstance().urlApi.length > 0) {
                tokenTAG = 'token-import-NP';
            } else {
                if (request.url.indexOf(MainComponent.getInstance().urlApiBDT) > -1 &&
                    MainComponent.getInstance().urlApiBDT.length > 0 && MainComponent.getInstance().urlApiBDT.length > 0) {
                    tokenTAG = 'token-import-BDT';
                } else {
                    if (request.url.indexOf(MainComponent.getInstance().urlApiIntranet) > -1 &&
                        MainComponent.getInstance().urlApiIntranet.length > 0 && MainComponent.getInstance().urlApiIntranet.length > 0) {
                        tokenTAG = 'token-import-Intranet';
                    } else {
                        if (request.url.indexOf(MainComponent.getInstance().urlApiEcoSAT) > -1 &&
                            MainComponent.getInstance().urlApiEcoSAT.length > 0 && MainComponent.getInstance().urlApiEcoSAT.length > 0) {
                            tokenTAG = 'token-import-EcoSAT';
                        } else {
                            return next.handle(request);
                        }
                    }
                }
            }
        }

        const b = sessionStorage.getItem(tokenTAG);

        const newRequest = request.clone({
            setHeaders: {
                Authorization: `Bearer ${sessionStorage.getItem(tokenTAG)}`
            }
        });
        return next.handle(newRequest);
    }
}
